"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getSchemaFromTypedModel_1 = require("../getSchemaFromTypedModel");
const recursiveClean_1 = __importDefault(require("./recursiveClean"));
const defaultOptions = {
    autoConvert: true,
    filter: true,
    trimStrings: true,
    removeEmptyStrings: false
};
async function clean(schema, doc, opts = {}, ...args) {
    if (!doc)
        return doc;
    schema = (0, getSchemaFromTypedModel_1.getSchemaFromTypedModel)(schema);
    const options = { ...defaultOptions, ...opts };
    const params = {
        schema: { type: schema },
        value: doc,
        doc: options.forceDoc || doc,
        currentDoc: doc,
        options,
        args
    };
    const cleanedResult = await (0, recursiveClean_1.default)(params);
    return cleanedResult;
}
exports.default = clean;
